import { Canvas } from "@components/PerformanceChart/Canvas";
import { EmptyPath } from "@components/PerformanceChart/MainPath";
import { PerformanceChartProps } from "@components/PerformanceChart/types";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { PerformanceChartProvider } from "@contexts/PerformanceChartContext";
import { useStyles } from "./styles";

export const PerformanceChartPlaceholder = (props: PerformanceChartProps) => {
  return (
    <PerformanceChartProvider data={props.data}>
      <PerformanceChartPlaceholderComponent {...props} />
    </PerformanceChartProvider>
  );
};

export const PerformanceChartPlaceholderComponent = ({ children }: PerformanceChartProps) => {
  const styles = useStyles();

  return (
    <div style={styles.container}>
      {children}
      <Spacing size={SpacingSizes.XL} />

      <Canvas>
        <EmptyPath />
      </Canvas>
      <Spacing size={SpacingSizes.M} />
    </div>
  );
};
